import { Component, computed, inject, signal } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { VisioComponentsModule } from '@visio-ai/ui-kit'
import { ScheduleRulesFiltersComponent } from '../../features/schedule-rules-filters/schedule-rules-filters.component'
import { ScheduleRulesInfiniteScrollComponent } from '../../features/schedule-rules-infinite-scroll/schedule-rules-infinite-scroll.component'
import { ScheduleRule } from '../../models/schedule-rule.model'
import { ScheduleRuleActionsService } from '../../services/schedule-rule-actions.service'
import { ShopsService } from '../../services/shops.service'
import { SupabaseService } from '../../services/supabase.service'
import { UsersService } from '../../services/users.service'

@Component({
  selector: 'app-schedule-rules-list',
  imports: [
    ScheduleRulesFiltersComponent,
    ScheduleRulesInfiniteScrollComponent,
    VisioComponentsModule
  ],
  templateUrl: './schedule-rules-list.component.html',
  styleUrl: './schedule-rules-list.component.scss'
})
export class ScheduleRulesListComponent {
  private supabase = inject(SupabaseService)
  private shopsService = inject(ShopsService)
  private usersService = inject(UsersService)
  private actions = inject(ScheduleRuleActionsService)

  private shopsList$ = this.shopsService.listShops()
  private usersList$ = this.usersService.listUsers()

  scheduleRules = signal<ScheduleRule[]>([])
  filteredRules = signal<ScheduleRule[]>([])

  shopsList = toSignal(this.shopsList$, { initialValue: [] })
  shopNameMap = computed(() => new Map(this.shopsList().map(shop => [shop._id, shop.nome])))

  usersList = toSignal(this.usersList$, { initialValue: [] })
  userNameMap = computed(() => new Map(this.usersList().map(user => [user._id, user.nome])))

  ruleUpdateLoading = signal(false)

  ngOnInit() {
    this.actions.initSession()
    this.loadScheduleRules()
  }

  private loadScheduleRules() {
    this.supabase.listScheduleRules().subscribe(rules => {
      this.scheduleRules.set(rules)
    })
  }

  onToggleActive(event: { id: string; active: boolean }) {
    this.supabase.updateScheduleRule(event.id, { active: event.active }).subscribe(updatedRule => {
      if (updatedRule) {
        this.scheduleRules.set(this.scheduleRules().map(r => (r.id === event.id ? updatedRule : r)))
      }
    })
  }

  onUpdateWeekdays(event: { id: string; weekdays: number[] }) {
    this.supabase
      .updateScheduleRule(event.id, this.actions.buildWeekdayUpdate(event.weekdays))
      .subscribe(updatedRule => {
        if (updatedRule) {
          this.scheduleRules.set(this.scheduleRules().map(r => (r.id === event.id ? updatedRule : r)))
        }
      })
  }

  onRequestSingleShopUpdateFromAdmin(shopId: string) {
    this.requestUpdateFromAdmin(shopId)
  }

  onUpdateSchedulingRequirements(event: { shopId: string; requirements: string }) {
    this.actions
      .saveSchedulingRequirements(event.shopId, event.requirements)
      .subscribe(() => this.loadScheduleRules())
  }

  requestUpdateFromAdmin(shopId?: string) {
    this.actions
      .confirmUpdateFromAdmin(
        'schedule-recurrence-popup',
        shopId,
        () => this.ruleUpdateLoading.set(true)
      )
      .subscribe(() => {
        this.ruleUpdateLoading.set(false)
        this.loadScheduleRules()
      })
  }
}
